import {UserRestService} from './restServices';
import storageService from '../storageService';
import scheduleUtils from '../../components/scheduleComponents/scheduleUtils';
var service = {};

function capitalizeFirstLetter(string = '') {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

service.capitalizeFirstLetter = capitalizeFirstLetter;

service.getUserByEmail = (
  email,
  token,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  token = token ? token : storageService.getItem('token');
  // console.debug(token);
  UserRestService.get(
    {
      endpoint: 'email',
      endpointParam: email,
      token: token,
    },
    {},
    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        resource.userDto.firstName = capitalizeFirstLetter(
          resource.userDto.firstName,
        );
        resource.userDto.lastName = capitalizeFirstLetter(
          resource.userDto.lastName,
        );
        successCallbackFunction(resource.userDto);
        return resource;
      } else {
        return resource.userDto;
      }
    },
    function (response) {
      // failure;
      failureCallbackFunction(response);
      return null;
    },
  );
};

service.getUserByUserId = (
  userId,
  token,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  token = token ? token : storageService.getItem('token');
  // console.debug(token);
  UserRestService.get(
    {
      endpoint: 'userId',
      endpointParam: userId,
      token: token,
    },
    {},
    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        resource.userDto.firstName = capitalizeFirstLetter(
          resource.userDto.firstName,
        );
        resource.userDto.lastName = capitalizeFirstLetter(
          resource.userDto.lastName,
        );
        successCallbackFunction(resource.userDto);
        return resource;
      } else {
        return resource.userDto;
      }
    },
    function (response) {
      // failure
      failureCallbackFunction(response);
      return null;
    },
  );
};

service.getAllUsers = (
  successCallbackFunction,
  failCallbackFunction,
  pageSize,
  token,
) => {
  token = token ? token : storageService.getItem('token');
  UserRestService.get(
    {
      endpoint: 'all',
      endpointParam: null,
      token: token,
      pageSize: pageSize,
    },
    function (resources) {
      // success
      if (successCallbackFunction) {
        successCallbackFunction(resources);
        return resources;
      } else {
        return resources;
      }
    },
    function (response) {
      // failure
      if (failCallbackFunction) {
        failCallbackFunction(response);
        return response;
      } else {
        return response;
      }
    },
  );
};

service.createUser = (
  user,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  user.firstName = capitalizeFirstLetter(user.firstName);
  user.lastName = capitalizeFirstLetter(user.lastName);
  UserRestService.save(
    {
      endpoint: 'email',
      endpointParam: null,
    },
    {
      userDto: user,
      timezone: user.timezone,
      password: user.password,
      partnerAffiliateId: user.partnerAffiliateId,
      marketingParameterDto: user.marketingParameterDto,
      marketingParameterAvailable: user.marketingParameterAvailable,
      activationToken: user.activationToken,
    },
    function (resource) {
      successCallbackFunction(resource);
    }, // success
    function (response) {
      failureCallbackFunction(response);
    },
  ); // failure
};

service.createEmailUser = (
  newUserObj,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  UserRestService.save(
    {
      endpoint: 'emailUser',
      endpointParam: null,
    },
    {
      email: newUserObj.email,
      timeZone: newUserObj.timezone
        ? newUserObj.timezone
        : scheduleUtils.generateGuessedTimezone(),
      firstName: newUserObj.firstName,
      lastName: newUserObj.lastName,
    },
    (resource) => {
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    }, // success
    (response) => {
      if (failureCallbackFunction) {
        failureCallbackFunction(response);
      }
    },
  ); // failure
};

service.updateUserByUserId = (
  userDto,
  successCallbackFunction,
  failCallbackFunction,
) => {
  userDto.firstName = capitalizeFirstLetter(userDto.firstName);
  userDto.lastName = capitalizeFirstLetter(userDto.lastName);

  var newUserRequestObject = {
    token: storageService.getItem('token'),
    userDto: userDto,
  };

  UserRestService.update(
    {
      endpoint: 'userId',
      endpointParam: userDto.userId,
    },
    newUserRequestObject,
    function (resource) {
      successCallbackFunction(resource.userDto);
    }, // success
    function (response) {
      if (failCallbackFunction) {
        failCallbackFunction(response.data);
      }
    },
  ); // failure
};

service.deleteUser = (
  email,
  token,
  // successCallbackFunction,
  // failureCallbackFunction,
) => {
  UserRestService.save(
    {
      endpoint: 'delete',
      endpointParam: null,
    },
    {
      email: email,
      token: token,
    },
    function () {
      //successCallbackFunction(resource);
    }, // success
    function () {
      //failureCallbackFunction(response);
    },
  ); // failure
};

service.deleteAllUsers = (
  token,
  // successCallbackFunction,
  // failureCallbackFunction,
) => {
  UserRestService.save(
    {
      endpoint: 'all',
      endpointParam: null,
    },
    {
      token: token,
    },
    function () {
      // successCallbackFunction(resource);
    }, // success
    function () {
      // failureCallbackFunction(response);
    },
  ); // failure
};

service.createGuestUser = (successCallbackFunction, failCallbackFunction) => {
  UserRestService.save(
    {
      endpoint: 'guest',
    },
    {},
    function (resource) {
      successCallbackFunction(resource.userDto);
    }, // success
    function (response) {
      failCallbackFunction(response);
    },
  );
};

service.toggleAvailability = (
  userId,
  newStatus,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  var newStatusRequestObject = {
    token: storageService.getItem('token'),
    availabilityStatus: newStatus,
  };
  UserRestService.update(
    {
      endpoint: 'toggleavilabilty',
      endpointParam: userId,
    },
    newStatusRequestObject,
    function (resource) {
      successCallbackFunction(resource.avilabilty);
    }, // success
    function (response) {
      if (failureCallbackFunction) {
        failureCallbackFunction(response.data);
      }
    },
  );
};

service.getEmailUserByResellerActivationToken = (
  token,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  // console.debug(token);
  UserRestService.save(
    {
      endpoint: 'resellerActivationToken',
      endpointParam: token,
    },
    {},
    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.userDto);
        return resource;
      } else {
        return resource.userDto;
      }
    },
    function (response) {
      // failure
      failureCallbackFunction(response);
      return null;
    },
  );
};

service.changeEmail = (
  userId,
  email,
  newEmail,
  password,
  successCallbackFunction,
  failureCallbackFunction,
) => {
  const newStatusRequestObject = {
    token: storageService.getItem('token'),
    email,
    newEmail,
    userId,
    password,
  };
  UserRestService.update(
    {
      endpoint: 'email',
    },
    newStatusRequestObject,
    function (resource) {
      successCallbackFunction && successCallbackFunction(resource.avilabilty);
    }, // success
    function (response) {
      if (failureCallbackFunction) {
        failureCallbackFunction(response.data);
      }
    },
  );
};

const userService = {...service};
export default userService;
